import { StarFilled } from '@ant-design/icons';
import { Checkbox, Radio, Space } from 'antd';
import React from 'react';
import { Trans } from 'react-i18next';

import { QuestionAlternativeCollection } from '../../types';

interface CandidateAnswerAlternativesProps {
  questionType: string;
  questionAlternatives?: QuestionAlternativeCollection[];
  answerAlternatives?: QuestionAlternativeCollection['id'][];
  isScreening?: boolean;
}

const getStyle = (
  isSelected: boolean,
  isCorrect: boolean,
  isScreening?: boolean
): React.CSSProperties => {
  return {
    ...(isScreening && isSelected ? { backgroundColor: isCorrect ? '#F6FFED' : '#F5F5F5' } : {}),
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '8px 0px',
  };
};

const CandidateAnswerAlternatives = ({
  questionType,
  questionAlternatives,
  answerAlternatives,
  isScreening,
}: CandidateAnswerAlternativesProps) => {
  return (
    <Space direction="vertical" size="middle" style={{ fontSize: 14 }}>
      {questionAlternatives?.map((questionAlternative) => {
        const isSelected = answerAlternatives
          ? answerAlternatives.includes(questionAlternative.id)
          : false;
        const desiredLabel = isScreening && questionAlternative.is_correct && (
          <span
            style={{
              color: '#722ED1',
              display: 'flex',
              alignItems: 'center',
              gap: 4,
            }}
          >
            <StarFilled />
            <Trans>Resposta desejada</Trans>
          </span>
        );

        if (questionType === 'RADIO')
          return (
            <div
              key={questionAlternative.id}
              style={getStyle(isSelected, questionAlternative.is_correct, isScreening)}
            >
              <Radio disabled checked={isSelected}>
                {questionAlternative.description}
              </Radio>
              {desiredLabel}
            </div>
          );

        if (questionType === 'CHECKBOX')
          return (
            <div
              key={questionAlternative.id}
              style={getStyle(isSelected, questionAlternative.is_correct, isScreening)}
            >
              <Checkbox disabled checked={isSelected}>
                {questionAlternative.description}
              </Checkbox>
              {desiredLabel}
            </div>
          );

        return <></>;
      })}
    </Space>
  );
};

export default CandidateAnswerAlternatives;
